/* eslint-disable react/no-danger */
/* eslint-disable no-return-assign */
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Responsive } from 'common/components';
import { CSSTransition } from 'react-transition-group';
import _ from 'lodash';
import { ROOT_ROUTE } from 'client/constants';
import Socials from 'client/components/common/Header/Socials';
import { Header, RabbiCredit, Container } from 'client/components/common';
// import centerLogoImg from 'assets/client/imgs/site-logo.svg';

import * as api from 'api';
import MobilePopup from '../ChoicePage/MobilePopup';
import * as css from './ResultPage.scss';

export default class ResultPage extends React.PureComponent {
	static propTypes = {
		className: PropTypes.string,
		items: PropTypes.shape({}),
		getItems: PropTypes.func.isRequired,
		history: PropTypes.shape({}).isRequired,
		selection: PropTypes.shape({}).isRequired,
		isStarted: PropTypes.bool.isRequired,
		in: PropTypes.bool.isRequired,
		songsCategory: PropTypes.shape({}).isRequired,
		// user: PropTypes.shape({}),
	};

	static defaultProps = {
		className: '',
		items: {},
		// user: null,
	};

	state = {
		animationState: '',
	};

	constructor(props) {
		super(props);

		this.embedCodeRef = React.createRef();

		this.state = {
			isPopUpShown: false,
			selectedItems: [],
		};
	}

	async componentDidMount() {
		const data = _.get(this.props, 'items.data', {});
		// if (!localStorage.getItem('isFirstVisitv2')) {
		const c = document.createElement('div');
		c.id = 'story-mako/ywpT2T_i_';
		c.dataset.domain = 'https://story.mako.co.il/ywpT2T_i_/';
		this.embedCodeRef.current.appendChild(c);

		const s = document.createElement('script');
		s.src = 'https://story.mako.co.il/ywpT2T_i_/sdk-prod.js?buildId=a2406ff2-942d-4b85-ab4c-f3ce700a3c73-0&ver=2';
		s.dataset.id = 'mako/ywpT2T_i_';
		s.async = true;
		// s.onload = () => {
		// 		window.embedStory('mako/ywpT2T_i_', { start: 'in-view' });
		// 	}
		// 	window.__storyLoaded = true;
		// 	if (Responsive.isMatching(Responsive.MOBILE)) {
		// 		window.scrollTo(0, 200);
		// 	}
		// };
		this.embedCodeRef.current.appendChild(s);

		setTimeout(() => {
			this.isFirstVisit();
		}, 6000);
		// }

		if (_.isEmpty(data)) {
			await this.props.getItems('שירהשנה');
		}

		const result = await api.getParticipant({ participantId: this.getUserId() });

		if (result.success && result.data) {
			this.setState({ selectedItems: result.data });
		}
	}

	animate = (node, done) => {
		if (this.props.in) {
			this.setState({ animationState: 'in' });
			setTimeout(done, parseInt(css.animationInTime, 10));
		} else {
			this.setState({ animationState: 'out' });
			setTimeout(done, parseInt(css.animationOutTime, 10));
		}
	};

	isFirstVisit = () => {
		localStorage.setItem('isFirstVisitv2', true);
	};

	getUserId = () => {
		return localStorage.getItem('__uid__v2');
	};

	getIsVotedOnce = () => {
		return localStorage.getItem('__f__v2');
	};

	onScreenShotClick = e => {
		e.preventDefault();
		this.setState({ isPopUpShown: true });
	};

	render() {
		if (!this.getUserId() || !this.getIsVotedOnce()) {
			return <Redirect to={ROOT_ROUTE} />;
		}

		const { className, isStarted } = this.props;
		const { animationState } = this.state;
		const cssTProps = _.omit(this.props, [
			'className',
			'isStarted',
			'staticContext',
			'history',
			'submitSelection',
			'getItems',
			'items',
			'user',
			'songsCategory',
			'selection',
		]);

		return (
			<CSSTransition {...cssTProps} addEndListener={this.animate}>
				<div className={classNames(css.resultPage, isStarted && css[animationState], className)}>
					<Header className={css.header} isHiddenOnMain />
					{Responsive.isMatching(Responsive.DESKTOP) && (
						<div
							className={css.genearlBg}
							style={{ backgroundImage: 'url(/assets/client/imgs/general-bg.png)' }}
						></div>
					)}
					<Container className={css.resultPageContainer}>
						<div className={css.resultPageContent}>
							{/* <div className={css.logoWrap}>
								<img className={css.logo} src={centerLogoImg} alt="logo" />
							</div> */}
							<div className={css.resultWrapper}>
								<div className={css.mainTitle}>תודה שהצבעתם!</div>
								<div className={css.mainSubTitle}>
									מצעד הבילאומי השנתי 2025 ישודר בגלגלצ ב-31 בדצמבר, יום רביעי, בין השעות 18:00-15:00
								</div>
								<div className={css.shareResult}>
									<h6 className={css.shareResultTitle}>שתפו את התוצאות </h6>
									<Socials
										className={css.socials}
										choiceId={this.getUserId()}
										onScreenShotClick={this.onScreenShotClick}
										isContentStyles
									/>
								</div>
							</div>
							<div className={css.embedCodeWrapper}>
								<div className={css.embedCode} ref={this.embedCodeRef}></div>
							</div>
						</div>
					</Container>
					{this.state.isPopUpShown && (
						<MobilePopup
							selection={this.state.selectedItems[_.get(this.props.songsCategory, 'id')]}
							isShowPopup={this.state.isPopUpShown}
							hidePopup={() => this.setState({ isPopUpShown: false })}
						/>
					)}
					{!this.state.isPopUpShown && <RabbiCredit className={css.rabbiCredit} theme="light" />}
				</div>
			</CSSTransition>
		);
	}
}
